










































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class AppSelector extends Vue {
  @Prop(Number) readonly value!: number;
  @Prop(String) readonly label!: string;
  @Prop({ type: String }) readonly placeholder!: string;
  @Prop({ type: Boolean, default: false }) readonly required!: boolean;
  @Prop({ type: [Number, String], default: 289 }) readonly width!:
    | number
    | string;

  @Prop({ type: [Number, String], default: 36 }) readonly height!:
    | number
    | string;

  @Prop({ type: Array }) readonly items!: string[];
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  model = '';

  rules = {
    required: (value: number) => !!value || '不能为空！'
  };

  mounted () {
    this.model = this.value === -1 ? '' : this.items[this.value]
  }

  @Watch('value')
  onValueChanged (val: number) {
    this.model = val === -1 ? '' : this.items[val]
  }

  @Emit('input')
  valueChangedHandler (val: string, index: number) {
    this.model = val
    return index
  }

  @Emit()
  submit () {
    // do nothing
  }
}
